import React from 'react';
import { connect } from 'react-redux';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import i18n from '../../i18n/i18n';
import { wentWrong } from "../../utils/ToastConfig";
import axios from '../../utils/AxiosWrapper';
import { Delete } from '../../utils/Delete';
import { deleteUser, getUsers } from '../../actions/users/UserActions';
import AddUser from './AddUser';
import css from './viewUsers.module.css';
import AddIcon from '@material-ui/icons/Add';
import SearchBar from 'material-ui-search-bar';
import { Tooltip as Tooltip2 } from '@material-ui/core';
import { Button, Tooltip, IconButton, Menu } from '@material-ui/core';
import * as Icons from '@material-ui/icons';
import { PulseLoader } from 'react-spinners';
import { withStyles } from '@material-ui/core/styles';

const commonHeaderStyle = {
    textAlign: 'center',
    textTransform: 'uppercase',
    paddingTop: 10,
    paddingBottom: 10,
    backgroundColor: '#04764e',
    color: "#ffff",
};

const styles = theme => ({
    primaryMain: { backgroundColor: theme.palette.primary.main },
    paginationButton: {
        borderRadius: '50%',
        width: '30px',
        height: '30px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#5EB3E4',
        color: 'white',
        border: 'none',
        cursor: 'pointer'
    },
    headerStyle: {
        textAlign: 'center',
        textTransform: 'uppercase',
        paddingTop: 10,
        paddingBottom: 10
    },
});

class ViewUsers extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            workplaceType: [], groupType: [], userType: [],
            showFilters: false, load: false,
            page: 0, pageSize: 10, sorted: null, filtered: null,
            selection: [], selectAll: false, selectedRow: [],
            totalPages: 0, totalUsers: 0,
            add: false, edit: false, delete: false,
            data: [],
            //----------
            editObject: null,
            searchBarValue: "",
            deleteItemId: -1,
            selectedUser: "",
            users: [],
        };
    }

    componentDidMount() {
        this.getByURL('korisnik/filter_user', 'userType');   // Preuzima filtere korisnika
        this.getUsers();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.searchBarValue !== this.state.searchBarValue ||
            prevState.selectedUser !== this.state.selectedUser
        ) {
            this.setState({
                load: true
            });
            this.reactTable.fireFetchData();
        }
    }

    getData(state) {
        this.setState({ load: true, data: [] });

        let filtered = [...state.filtered];

        if (this.state.searchBarValue) {
            // filtered.push({ id: 'ime', value: this.state.searchBarValue });
            // filtered.push({ id: 'prezime', value: this.state.searchBarValue });
            filtered.push({ id: 'ime_prezime', value: this.state.searchBarValue });
        }

        axios.get(`api/korisnik/read`, {
            params: { page: state.page, pageSize: state.pageSize, sorted: state.sorted, filtered: filtered }
        })
            .then(res => {
                this.setState({
                    data: res.data.data,
                    totalPages: res.data.total_pages,
                    totalUsers: res.data.total,
                    load: false
                });
            })
            .catch(error => {
                wentWrong('Something went wrong, please try again!');
                console.log('Error 1 (getData): ', error);
            });
    }

    getUsers(edit) {
        axios.get(`api/sektor/drop_down`)
            .then(res => {
                const usersFromApi = res.data.data
                    .map(item => ({ id: item.id, value: item.naziv }));
                if (edit) {
                    let usersForEdit = usersFromApi;
                    let temp = [...this.state.users];
                    for (let i = 0; i < usersForEdit.length; i++) {
                        let element = usersForEdit[i];
                        if (!temp.some(item => item.id === element.id)) {
                            temp.push(element);
                        }
                    }
                    this.setState({
                        users: temp,
                    });
                } else {
                    this.setState({
                        users: usersFromApi
                    });
                }
            })
            .catch(error => {
                wentWrong('Something went wrong, please try again!');
                console.log('Error 1 (getUsers): ', error);
            });
    }

    // handleOpenNewUser = () => {
    //     this.setState({ add: true });
    //     if (this.state.edit === false) {
    //         this.setState({
    //             editObject: null
    //         });
    //     }
    // };

    handleOpenNewUser = () => {
        this.setState({
            add: false, // Prvo zatvori modal ako je već bio otvoren
        }, () => {
            this.setState({
                add: true,
                edit: false,
                editObject: {
                    id: undefined,
                    ime: '',
                    prezime: '',
                    username: '',
                    password: '',
                    repeat_password: '',
                    mejl: '',
                    mobilni: '',
                    id_korisnik_grupa: '',
                    id_sektor: ''
                }
            });
        });
    };

    handleCloseNewUser = () => {
        this.setState({
            add: false,
            edit: false,
            editObject: null
        });
    };



    onCreate = () => {
        this.setState({
            add: false,
            load: true,
            edit: false,
            page: 0
        }, () => {
            if (this.reactTable) {
                const { page, pageSize } = this.reactTable.state;
                if (page !== 0 || pageSize !== this.state.pageSize) {
                    this.reactTable.state.page = 0;
                }
                // Osveži korisnike
                //this.getUsers();
                this.reactTable.fireFetchData();
            }
        });
    };

    getByURL(url, obj) {
        axios.get(`api/${url}`)
            .then(res => this.setState({ [obj]: res.data.data }))
            .catch(error => {
                wentWrong('Something went wrong, please try again!');
                console.log('Error 2 (getByURL): ', error, ', URL: ', url);
            });
    }

    handleSearchBar = (searchVal) => {
        this.setState({
            searchBarValue: searchVal,
        });
    };

    deleteItem = () => {
        this.props.deleteUser(this.state.selection);
        this.setState({ delete: false })
    }

    // deleteItem = () => {
    //     axios.post(`api/korisnik/delete`, { selection: [this.state.deleteItemId] })
    //         .then(res => {
    //             if (this.reactTable && this.reactTable.fireFetchData) {
    //                 this.reactTable.fireFetchData();
    //             }
    //             this.getUsers(); // Osveži korisnike nakon brisanja
    //             this.setState({ delete: false });
    //         })
    //         .catch(err => {
    //             this.setState({ delete: false });
    //             console.log('Error while deleting user: ', err);
    //         });
    // };

    async countByKorisnikId(id) {
        let count = 0;
        let count2 = 0;
        try {
            const [res1, res2] = await Promise.all([
                axios.post('api/korisnik/count_by_korisnik_id', { id }),
                axios.post('api/korisnik/count_by_korisnik_id2', { id })
            ]);
            count = res1.data.count || 0;
            count2 = res2.data.count || 0;
        } catch (err) {
            console.log(err);
        }
        return count + count2;
    }

    handleDeleteButtonClick = async () => {
        const id = this.state.deleteItemId;
        let count = await this.countByKorisnikId(id); //PROMENI

        if (count > 0) {
            wentWrong(i18n.t('You cannot delete user that has history!'));


            this.setState({ deleteUser: false });
        } else {
            await axios.post('api/korisnik/delete', { selection: [id] });
            this.setState({ deleteUser: false });
            if (this.reactTable && this.reactTable.fireFetchData) {
                this.reactTable.fireFetchData();
            }
        }
    }

    closeDeleteUser = () => {
        this.setState({ deleteUser: false });
        this.getUsers();
    };

    onSearchClick = () => this.setState({ showFilters: !this.state.showFilters });
    onEditClick() { this.setState({ add: !this.state.add, edit: true }); }
    //onDeleteClick = () => { this.setState({ delete: !this.state.delete }); }

    render() {
        const { classes } = this.props;

        const columns = [

            {
                Header: i18n.t('Username'),
                accessor: 'username',
                headerStyle: commonHeaderStyle
            },
            {
                Header: i18n.t('Client name'),
                accessor: 'klijent_naziv',
                headerStyle: commonHeaderStyle
            },
            {
                Header: i18n.t('Email'),
                accessor: 'mejl',
                headerStyle: commonHeaderStyle
            },
            {
                Header: i18n.t('First and last name'),
                accessor: 'ime_prezime',
                headerStyle: commonHeaderStyle
            },
            {
                Header: i18n.t('Sektor'),
                accessor: 'sektor_naziv',
                headerStyle: commonHeaderStyle
            },
            {
                Header: i18n.t('User role'),
                accessor: 'korisnik_grupa',
                headerStyle: commonHeaderStyle
            },
            {
                Header: i18n.t('Mobile phone'),
                accessor: 'mobilni',
                headerStyle: commonHeaderStyle
            },
            {
                width: 80,
                Header: i18n.t('Edit'),
                accessor: 'izmena',
                getHeaderProps: () => ({
                    onClick: e => e.stopPropagation(),
                    style: { cursor: 'default' }
                }),
                headerStyle: {
                    textAlign: 'center',
                    textTransform: 'uppercase',
                    paddingTop: 10,
                    paddingBottom: 10,
                    backgroundColor: "#04764e",
                    color: '#FFFFFF'
                },
                Cell: cell => (
                    <div>
                        <Tooltip2 title={i18n.t("Edit")}>
                            <IconButton aria-label="edit"
                                onClick={() => {
                                    this.setState({
                                        edit: true,
                                        editObject: cell.row._original,
                                        add: true
                                    });
                                }}
                            // onClick={() => {
                            //     console.log("edit", cell.row._original);
                            //     this.setState({
                            //         edit: true,
                            //         editObject: cell.row._original
                            //     }, () => {
                            //         this.handleOpenNewUser();
                            //     });
                            // }}
                            >
                                <Icons.Edit fontSize="default" />
                            </IconButton>
                        </Tooltip2>
                    </div>
                )
            },
            {
                width: 80,
                Header: i18n.t('Delete'),
                accessor: 'detalji',
                getHeaderProps: () => ({
                    onClick: e => e.stopPropagation(),
                    style: { cursor: 'default' }
                }),
                headerStyle: {
                    textAlign: 'center',
                    textTransform: 'uppercase',
                    paddingTop: 10,
                    paddingBottom: 10,
                    backgroundColor: "#04764e",
                    color: '#FFFFFF'
                },
                Cell: cell => (
                    <div>
                        <Tooltip2 title={i18n.t("Delete")}>
                            <IconButton aria-label="delete"
                                onClick={() => {
                                    this.setState({
                                        deleteItemId: cell.row._original.id,
                                        deleteUser: true
                                    });

                                }}
                            >
                                <Icons.DeleteOutline fontSize="default" />
                            </IconButton>
                        </Tooltip2>
                    </div>
                )
            },
        ];
        const url = 'korisnik/read';

        const { selectAll } = this.state;
        const checkboxProps = {
            selectAll,
            isSelected: this.isSelected,
            toggleSelection: this.toggleSelection,
            toggleAll: this.toggleAll,
            selectType: "checkbox",
            getTrProps: (state, rowInfo, instance) => {
                if (rowInfo) {
                    const selected = this.isSelected(rowInfo.original.id);
                    return { style: { backgroundColor: selected ? "#ACDAF1" : "inherit", alignItems: 'flex-end' } };
                }
                return {};
            },
            getTheadFilterProps: () => ({ style: { backgroundColor: '#58B4E5' } }),
            getTheadTrProps: () => ({ style: { backgroundColor: '#04764e', color: '#FFFFFF' } }),
        };

        return (
            <>
                <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                    <div className={css.searchWrap}>
                        <SearchBar
                            className={css.searchBar}
                            placeholder={i18n.t('Search by name')}
                            cancelOnEscape={true}
                            value={this.state.searchBarValue}
                            onChange={(searchValue) => this.handleSearchBar(searchValue)}
                            onCancelSearch={() => this.handleSearchBar('')}
                        />
                        <Button
                            variant="fab"
                            color="primary"
                            aria-label="Add"
                            className={css.addNewBtn}
                            onClick={() => { this.handleOpenNewUser() }}
                        >
                            <AddIcon />
                            {i18n.t('Add user')}
                        </Button>
                    </div>
                    {/* <div className={css.filtersSection}>
                        <select className={css.dropDowns} value={this.state.selectedUser} onChange={this.handleChangeUsers} >
                            <option value="">{i18n.t('User')}</option>
                            {this.state.users && this.state.users.map((user, i) => (
                                <option key={i} value={user.id}>{user.value}</option>
                            ))}
                        </select>
                    </div> */}
                    <div style={{ border: '1px solid #cecece', backgroundColor: '#fff', margin: '30px', borderRadius: '3px', boxSizing: 'border-box', overflow: 'hidden', boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.5)', display: 'flex', flexDirection: 'column' }}>
                        <ReactTable ref={r => (this.reactTable = r)}
                            manual
                            useSortBy
                            paging={true}
                            data={this.state.data}
                            columns={columns}
                            keyField={'id'}
                            pageRangeDisplayed={false}
                            defaultPageSize={this.state.pageSize}
                            pages={this.state.totalPages}
                            showPaginationBottom={true}
                            onFetchData={(state) => this.getData(state)}
                            previousText={'<'}
                            nextText={'>'}
                            pageText={''}
                            ofText={i18n.t('of')}
                            showPageSizeOptions={false}
                            showPagination={true}
                            rowsText={''}
                            PreviousComponent={(props) => (
                                <button {...props} className={classes.paginationButton}>
                                    {props.children}
                                </button>
                            )}
                            NextComponent={(props) => (
                                <button {...props} className={classes.paginationButton}>
                                    {props.children}
                                </button>
                            )}
                            getTrProps={() => ({
                                style: {
                                    textAlign: 'center',
                                    paddingLeft: '10px',
                                    height: '50px',
                                    alignItems: 'center',
                                    overflowY: 'hidden',
                                    overflowX: 'hidden',
                                }
                            })}
                            LoadingComponent={() => (
                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                    <PulseLoader loading={this.state.load} />
                                </div>
                            )}
                            onPageChange={() => { this.setState({ load: true }) }}
                            NoDataComponent={() => (
                                <div style={{
                                    textAlign: 'center',
                                    padding: '20px',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    marginTop: -300
                                }}>
                                    {!this.state.load && <span>{i18n.t('No rows found')}</span>}
                                </div>
                            )}
                        />
                    </div>
                </div>
                <AddUser
                    add={this.state.add}
                    edit={this.state.edit}
                    handleCreate={this.onCreate}
                    handleClose={this.handleCloseNewUser}
                    data={this.state.edit ? this.state.editObject :null}
                />
                {this.state.deleteUser && <Delete delete={this.state.deleteUser} handleClose={this.closeDeleteUser} deleteItem={this.handleDeleteButtonClick} />}           </>
        );
    }
}

export default withStyles(styles)(ViewUsers);